import React, { useState, } from "react";
import useSize from "../useSize/useSize";

import EditOptions from "./EditOptions";
import EditFooter from "./EditFooter";

import EditView from "./Edit/Edit";
import Settlement from "./Settlement/Settlement";
import Ledger from "./Ledger/Ledger";
import Trade from "./Trade/Trade";
import Standing from "./Standing/Standing";
import LoginLogs from "./LoginLogs/LoginLogs";
import UserList from "./UserList/UserList";
import UserSettlement from "./UserSettlement/UserSettlement";

import "./Edit.css";

export default function BrokerModal({ user_id, close }) {
  const [type, setType] = useState(1);

  const windowSize = useSize();

  const renderContent = () => {
    switch (type) {
      case 1:
        return <EditView user_id={user_id} />;
      case 2:
        return <Settlement user_id={user_id} />;
      case 3:
        return <Ledger user_id={user_id} />;
      case 4:
        return <Trade user_id={user_id} />;
      case 5:
        return <Standing user_id={user_id} />;
      case 6:
        return <LoginLogs user_id={user_id} />;
      case 7:
        return <UserList user_id={user_id} />;
      case 8:
        return <UserSettlement user_id={user_id} />;
      default:
        return null;
    }
  };

  return (
    <div
      className="EditModal shadow-lg rounded-xl bg-[var(--background)] border-2 border-[var(--hover)]"
      style={{
        height: windowSize[1] - 100,
        width: windowSize[0] - 100,
      }}
    >
      <EditOptions close={close} updateType={setType} type={type} />

      <div className="CreateList">{renderContent()}</div>

      <EditFooter user_id={user_id} />
    </div>
  );
}
